import { Entry } from 'contentful'
import { ISolutionPage as IContentfulSolutionPage } from 'marketing-site/@types/generated/contentful'
import { ISolutionPage } from 'marketing-site/src/components/common/pages/SolutionPage'
import { transformGatedContent } from 'marketing-site/src/mvp/transformers/components/ContentfulGatedContent'
import { transformHeroVertical } from 'marketing-site/src/mvp/transformers/components/ContentfulHeroVertical'
import { transformSolution } from '../models/ContentfulSolution'

export function isSolutionPage(entry: Entry<any>): entry is IContentfulSolutionPage {
  return entry.sys.contentType?.sys.id === 'solutionPage'
}

export function transformSolutionPage({ fields }: IContentfulSolutionPage): ISolutionPage {
  return {
    hero: fields.hero && transformHeroVertical(fields.hero),
    solution: fields.solution && transformSolution(fields.solution),
    footerCta: fields.footerCta && transformGatedContent(fields.footerCta),
  }
}
